import { useQuery } from '@apollo/client';
import {
  Button,
  Spacer,
  SvgLink,
  SvgPlayCircle,
  Text,
  TextButton,
  Tooltip,
} from '@loomhq/lens';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { SHARE_VIDEO } from 'constants/checklist';
import { GET_STARTED_CHECKLIST_COPY_LINK_CLICKED } from 'constants/events';
import { LOOM_URI } from 'constants/routes';
import { selectCurrentUser } from 'selectors/user';
import * as analytics from 'utilities/analytics';

import useClipboard from 'hooks/useClipboard';
import { useCompleteChecklistItem } from 'hooks/checklist';

import { RecentUserVideos } from '../../../../share-video/add-search-ui/graphql/RecentUserVideos.gql';

const now = new Date();

const ShareCTA = () => {
  const [videoLink, setVideoLink] = useState(null);
  const [isCopied, setCopied] = useClipboard(videoLink, {
    successDuration: 2000,
  });
  const user = useSelector(selectCurrentUser);
  const { completeChecklistItem } = useCompleteChecklistItem(SHARE_VIDEO);

  useQuery(RecentUserVideos, {
    variables: {
      startDate: user.createdAt,
      endDate: now,
      limit: 1,
      offset: 0,
    },
    onCompleted: ({ recentUserVideos }) => {
      if (recentUserVideos.length) {
        setVideoLink(`${LOOM_URI}/share/${recentUserVideos[0].id}`);
      }
    },
  });

  const tooltipText = !videoLink ? 'Record a video first, then share!' : null;

  return (
    <div>
      <Text>
        Now it&apos;s time to get some views. Try sharing your last video.
      </Text>
      <Spacer top="large" bottom="medium">
        <Tooltip content={tooltipText} placement="bottomCenter">
          <Button
            icon={<SvgLink />}
            variant="primary"
            isDisabled={!videoLink}
            onClick={() => {
              analytics.track(GET_STARTED_CHECKLIST_COPY_LINK_CLICKED);
              completeChecklistItem();
              setCopied();
            }}
          >
            {isCopied ? 'Link copied!' : 'Copy last video link'}
          </Button>
        </Tooltip>
      </Spacer>
      <TextButton
        icon={<SvgPlayCircle />}
        size="small"
        onClick={() => {
          document.location =
            'https://www.loom.com/share/29f210bc12484eaa81ca462381fb4415?t=0';
        }}
      >
        Learn how to share
      </TextButton>
    </div>
  );
};

export default ShareCTA;
